import { Component, Input, Inject } from "@angular/core";

import { OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FileUploadService } from 'src/services/file-upload.service';
import { LocationService } from 'src/services/location.services';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { MedicineService } from 'src/services/medicine.services';
import { MessageService } from 'src/services/message.service';
import { SubscriptionService } from 'src/services/subscription.service';

import {environment} from '../../environments/environment';

@Component({
  selector: "rm-add-product",
  templateUrl: "./add-product.component.html",
  styleUrls: ["./add-product.component.css"]
})
export class AddProductDialogComponent implements OnInit {
  defaultTitle: string = "Confirm";
  isFormValid: boolean = true;

  path: string = '../../assets/images/no-image.png';

  formGroup = new FormGroup({
    id: new FormControl(),
    gtin: new FormControl('', [Validators.minLength(14), Validators.maxLength(14)]),
    gln: new FormControl(),
    type: new FormControl(),
    name: new FormControl(),
    aNORCameroonStandardNumber: new FormControl(), // camtrade pass attribute
    composition: new FormControl(),
    units: new FormControl(),
    img: new FormControl(),
    // isTemperatureSensitive: new FormControl(),
    // isMoistureSensitive: new FormControl(),
    minTemperature: new FormControl(),
    maxTemperature: new FormControl(),
    minHumidity: new FormControl(),
    maxHumidity: new FormControl(),
    tempThreshold: new FormControl(),
    humidityThreshold: new FormControl(),
    expiryDateType: new FormControl('expiry'),
    // isLightExposureMonitoringOn: new FormControl(),
    // isShockMonitoringOn: new FormControl(),
    // isLocationTrackingOn: new FormControl(),
    // geofencing: new FormControl()
  });
  uploader: any;
  attachment: any;
  locations: any[];
  labels: any[];
  mode: any;
  showExpiryDateType: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<AddProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private uploadService: FileUploadService,
    private locationService: LocationService,
    private globalCfgService: GlobalCfgService,
    private medicineService: MedicineService,
    private msgService: MessageService,
    private subscriptionService: SubscriptionService
  ) { }

  ngOnInit() {
    this.labels = this.globalCfgService.getSettingValue('labels');

    this.mode = this.data.mode;

    this.uploader = this.uploadService.getUploader(environment.productPicsContainer);
    var gcp = this.globalCfgService.getGcp();
    this.loadLocationData(gcp);
    this.loadOrgData(gcp);

    if (this.data.data) {
      this.path = this.data.data.img;
      this.formGroup.setValue(this.data.data);
      this.formGroup.controls['gtin'].disable();
    } else {
      this.formGroup.controls["units"].setValue(1);
    }
  }

  cancel() {
    this.dialogRef.close("no");
  }

  onFileSelected() {
    this.uploader.response.subscribe(
      response => {

        this.attachment = JSON.parse(response)["result"]["files"]["file"][0];
        // this.path = "/uploads/" + this.attachment.container + "/" + this.attachment.name;

        //TODO: use this with AWS S3
        this.path = this.attachment.providerResponse.location;
        // console.log(this.path);
      },
      error => {
        console.log("File upload error:", error);
      }
    );
  }

  // product level expiry/retest date choice is only for orgs with this bulk api attribute
  loadOrgData(gcp) {
    const filter = { "where": { "gcp": gcp } };
    this.subscriptionService.getCurrentOrgData(filter).subscribe(
      (response: any) => {
        if (response.count === 1 && response.data[0].bulkApiAttributes) {
          const bulkApiAttributes = JSON.parse(JSON.parse(response.data[0].bulkApiAttributes));
          this.showExpiryDateType = !!(bulkApiAttributes && bulkApiAttributes.showExpiryDateType);
        }
      });
  }

  loadLocationData(gcp) {

    this.locationService.get(gcp).subscribe(
      (response: any[]) => {
        // console.log("response", response);
        this.locations = response;
      });
  }

  onSubmit(rec) {
    var data = {
      gtin: rec.gtin,
      gln: rec.gln,
      attributes: {
        name: rec.name,
        aNORCameroonStandardNumber: rec.aNORCameroonStandardNumber, // camtrade pass attribute
        type: rec.type,
        imgPath: this.path,
        composition: rec.composition,
        units: rec.units,
        minTemperature: rec.minTemperature,
        maxTemperature: rec.maxTemperature,
        tempThreshold: rec.tempThreshold,
        minHumidity: rec.minHumidity,
        maxHumidity: rec.maxHumidity,
        humidityThreshold: rec.humidityThreshold,
        flags: {
          isLightExposureMonitoringOn: false,
          isShockMonitoringOn: false,
          isTempSensitive: false,
          isMoistureSensitive: false,
          isLocationTrackingOn: false,
          geofencing: false
        }
      }
    }
    if (this.showExpiryDateType) {
      data.attributes['expiryDateType'] = rec.expiryDateType || 'expiry';
    }
    if (this.mode == 'edit') {
      this.medicineService.update(data).subscribe(
        () => {
          this.msgService.showSuccess(this.msgService.medicineUpdate);
          this.dialogRef.close('yes');
        }
      );
    } 
    else {
      this.medicineService.add(data).subscribe(
        () => {
          this.msgService.showSuccess(this.msgService.medicineCreate);
          this.dialogRef.close('yes');
        }
      );
    }
  }

}